<template>
  <v-dialog v-model="visible" max-width="500px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row>
            <v-col cols="12">
              <v-select
                v-model="form.conceptoId"
                :items="conceptos"
                label="Concepto"
                outlined
                dense
                hide-details
                item-text="nombre"
                item-value="id"
                clearable></v-select>

              <small v-for="error in errores.conceptoId" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="form.conceptoPagoEquivalenteId"
                :items="conceptosPagos"
                label="Concepto Pago Equivalente"
                outlined
                dense
                hide-details
                item-text="nombre"
                item-value="id"
                clearable>
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">
                      {{ item.nombre }}
                      <small>({{ item.agrupador.toUpperCase() }})</small>
                    </v-list-item-title>

                    <v-list-item-subtitle class="subtitle-2 text-uppercase">
                      <small>{{ item.unidadNegocio }}</small>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-select>

              <small v-for="error in errores.conceptoPagoEquivalenteId" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>

            <v-col cols="12">
              <div class="d-flex">
                <v-switch
                  style="margin-top: -4px"
                  v-model="form.esVerificable"
                  hide-details
                  label="Es verificable"></v-switch>
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text :disabled="enviando" @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="enviando"
          :loading="enviando"
          @click.prevent="() => validar(registrar, editar)">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import ConceptoUniversidadService from '../services/concepto-universidad.service';
import ConceptoService from '../services/concepto.service';
import ConceptosPagosService from '../services/conceptos-pagos.service';

export default {
  name: 'ModalFormularioConceptoUniversidad',
  mixins: [modalFormMixin, apiConsumerMixin],
  props: {
    universidadId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      conceptos: [],
      conceptosPagos: [],
    };
  },
  watch: {
    'form.conceptoId': function () {
      this.errores.conceptoId = [];
    },
    'form.conceptoPagoEquivalenteId': function () {
      this.errores.conceptoPagoEquivalenteId = [];
    },
    'form.esVerificable': function () {
      this.errores.esVerificable = [];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        conceptoId: null,
        universidadId: this.universidadId,
        conceptoPagoEquivalenteId: null,
        esVerificable: false,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        conceptoId: data.conceptoId,
        universidadId: data.universidadId,
        conceptoPagoEquivalenteId: data.conceptoPagoEquivalenteId,
        esVerificable: data.esVerificable,
      };
    },
    async obtenerConceptos() {
      await this.obtenerDatosMixin(ConceptoService.findAll, 'conceptos');
    },
    async obtenerConceptosPagos() {
      await this.obtenerDatosMixin(ConceptosPagosService.findAll, 'conceptosPagos');
    },
    abrir(accion, data = []) {
      Promise.all([this.obtenerConceptos(), this.obtenerConceptosPagos()]).then(() => {
        this.abrirMixin(accion, data);
      });
    },
    guardar(accion) {
      this.guardarDatosMixin(
        ConceptoUniversidadService.create,
        ConceptoUniversidadService.update,
        accion,
        this.form,
        this.nombreRecurso,
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
    registrar() {
      this.guardar(this.accionesCrud.REGISTRAR);
    },
    editar() {
      this.guardar(this.accionesCrud.EDITAR);
    },
  },
};
</script>